export default state => state.expressCheckout.expressIndex;
